import { styled } from "styled-components";

export const ContainerEstra = styled.div`
display: flex;
flex-direction: column;
width: 100%;
margin: 30px;

h1 {
  color: black;
  text-align: center;
  margin-bottom: 30px;
}
`;


export const ContainerTag = styled.div`
display: flex;
justify-content: center;
flex-wrap: wrap;
align-items: center;
align-content: center;
width: 100%;
height: auto;
margin: 5px;
`;


export const TagEstrategia = styled.span`
margin: 5px;
padding: 7px 16px;
width: auto;
height: 40px;
background-color: white;
border: 2px solid white;
border-radius: 20px;
font-weight: bold;
&:hover {
    background-color: transparent;
    color: white !important;
}
`;

export const DataPiramide = styled.div`
display: flex;
flex-direction: column;
width: 100%;
height: auto;
justify-content: flex-start;
flex-wrap: wrap;
align-items: center;
align-content: center;
row-gap: 15px;
border-radius: 15px;
padding: 15px;
`;

export const CustomPiramide = styled.div`

.piramide {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-content: center;
}



`;

export const LevelButton = styled.button`
  appearance: none;
  background-color: transparent !important;
  padding: 0;
  margin: 0;
  border: none;
  position: relative;
  line-height:0;
  img {
    width: 100%;
  }

  > span {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto auto;
    height: 30px;
    line-height: 22px;
    font-family: "CIB Sans Bold",sans-serif;
    font-size: 20px;
  }

  &.level-1 {
    width: 50px !important;
    @media (min-width: 1024px) {
      width: 200px !important;
    }
  }

  &.level-21 {
    width: 100px !important;
    > span {
      max-width: 340px;
    }
    @media (min-width: 1024px) {
      width: 400px !important;
    }
  }

  &.level-22 {
    width: 150px !important;
    @media (min-width: 1024px) {
      width: 600px !important;
    }
  }

  &.level-3 {
    width: 203px !important;
    margin-left: 3px;
    @media (min-width: 1024px) {
      width: 807px !important;
      margin-left: 7px;
    }
  }

`;

export const LevelDetail = styled.div`
  position: absolute;
  width: 300px;
  padding: 10px;
  line-height: 18px;
  border-radius: 8px;
  box-sizing: 2px 2px 4px rgba(0,0,0,.5);
  font-family: "Open Sans",sans-serif;

  &.level-1 {
    border: 2px solid #FF7F41;
    border-radius: 8px;
    top: 0;
    right: -300px;
  }

  &.level-21 {
    border: 2px solid #8F65CD;
    border-radius: 8px;
    top: 0;
    right: -300px;
  }

  &.level-22 {
    border: 2px solid #00CDEA;
    border-radius: 8px;
    top: 0;
    right: -300px;
  }

  &.level-3 {
    border: 2px solid #09A783;
    border-radius: 8px;
    top: 0;
    right: -300px;
  }
`;